export default __webpack_public_path__ + "static/media/consulta-saldo.bb3d3f3d.png";